import { registerIntentHandler } from './intentHandlers';
import { agPoolController } from './global-pool';
import HttpUtils from '@/framework/HttpUtils';
import { BigNumber } from 'ethers';
import { parseUnits } from 'ethers/lib/utils';

registerIntentHandler('mint', async (payload) => {
    if (!agPoolController) {
        console.error('AG Pool Controller is not initialized.');
        return;
    }
    const tx = await agPoolController.mint(payload.amount);
    console.log('User confirmed mint!', tx);
    const conetnt = 'Minting Success tx is ' + tx.hash + ' ,Please help me Check the balance of AGD token and USDT token。  Output format Markdown: "eg: Mint Success current AGD: 1000 , USDT:100"';
    HttpUtils.Post(`/chat/message?sessionId=${payload.address}`, { showMsg: false, role: 'user', promptId: 'mint', content: conetnt });
});

registerIntentHandler('burn', async (payload) => {
    if (!agPoolController) {
        console.error('AG Pool Controller is not initialized.');
        return;
    }
    const burnPrice = await agPoolController.evalBurnAmount(BigNumber.from(1));
    const usdtAmount = parseUnits(`${payload.amount}`, 'wei').mul(burnPrice);
    const tx = await agPoolController.burn(parseUnits(`${payload.amount}`), usdtAmount);
    const conetnt = 'Burning Success txHash is ' + tx.hash + ' ,Please help me Check the balance of AGD token and USDT token。  Output format Markdown : "eg: Burn Success current AGD: 1000 , USDT:100. For more transaction information, click https://testnet.bscscan.com/tx/ + ${txHash}';
    HttpUtils.Post(`/chat/message?sessionId=${payload.address}`, { showMsg: false, role: 'user', promptId: 'mint', content: conetnt });
});
